import React from 'react';
import proptypes from 'prop-types';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { extend, useDataModel } from '@thd-nucleus/data-sources';
import { StorePodContext } from './StorePod.context';
import { StorePodRating } from './modules/StorePodRating';
import { storeDataModel } from './storeDataModel';
import { storeShape } from './storeShape';
import { StorePodLoader } from './modules/StorePodLoader';

const { bool, node, oneOfType, number, string } = proptypes;

const StorePodComponent = ({
  children,
  loading = false,
  store = null,
  storeId = '',
  className = null
}) => {

  const fetchDataInternally = !!storeId;

  let contextValue = {
    isCanadianStore: store?.address?.country?.toUpperCase() === 'CA',
    isDesignStore: store?.storeType === 'hddc',
    loading,
    store: store || {}
  };

  const options = {
    variables: {
      storeSearchInput: storeId,
      pagesize: '1'
    },
    skip: !fetchDataInternally
  };

  const { data, error } = useDataModel('storeSearch', options);

  if (fetchDataInternally) {
    const storeObj = data?.storeSearch?.stores?.[0] || {};

    contextValue = {
      isCanadianStore: storeObj?.address?.country?.toUpperCase() === 'CA',
      isDesignStore: storeObj?.storeType === 'hddc',
      loading: !storeObj?.storeId,
      store: storeObj
    };
  }

  return (
    <div className={className} data-component="StorePod">
      <StorePodContext.Provider value={contextValue}>
        {children}
      </StorePodContext.Provider>
    </div>
  );
};

StorePodComponent.propTypes = {
  children: node.isRequired,
  loading: bool,
  store: storeShape,
  storeId: oneOfType([string, number]),
  className: string,
};

StorePodComponent.displayName = 'StorePod';
StorePodComponent.dataModel = storeDataModel;

const HydratedComponent = withHydrator({
  delay: 500,
  id: 'store-pod',
  placeholder: (
    <div data-component="StorePodLoader">
      <StorePodLoader height="400px" />
    </div>
  ),
  scrollBuffer: 100
}, StorePodComponent);

const StorePod = withDynamicComponent(HydratedComponent);

StorePod.dataModel = extend(StorePodRating, storeDataModel);

export { StorePod };
